import type { ConstValues } from '@openx/types/helpers.ts';
export type ExportType = ConstValues<typeof ExportType>;
export const ExportType = {
  OA_MATCH: 'oa_match',
  BIDSTREAM: 'bidstream',
  BIDSTREAM_PLUS: 'bidstream_plus',
} as const;

export const UNSUPPORTED_STATUSES_FOR_DEAL = [
  'publish_failed',
  'activate_failed',
  'export_failed',
  'expire_failed',
  'expired',
  'expiring',
  'draft',
] as const;
